import PhoneMock from "../components/PhoneMock";
import SiteFooter from "../components/SiteFooter";
import TopBar from "../components/TopBar";

const Hero = () => {
  return (
    <section className="hero" id="top">
      <div className="wrap hero__grid">
        <div className="hero__copy">
          <h1 className="hero__h1">
            A <span className="u">really great</span> internet radio player.
          </h1>

          <ul className="hero__points">
            <li>Listen to any station.</li>
            <li>Get a notification when your favorite show starts.</li>
            <li>Share what's good with your friends.</li>
          </ul>

          <div className="hero__cta">
            <a className="btn btn--lg" href="/beta">
              Start listening
            </a>
          </div>
        </div>

        <PhoneMock />
      </div>
    </section>
  );
};

const Homepage = () => {
  return (
    <>
      <TopBar />
      <main>
        <Hero />
        <div className="manifesto">
          <section className="section prose" id="about">
            <h2 className="section__title">
              A great app for listening to internet radio
            </h2>
            <div className="section__copy">
              <p>
                StreamLover was built to be the{" "}
                <strong className="u">best possible streaming radio app</strong>
                , by an indie developer who loves internet radio.
              </p>
              <p>
                Its most important job is to play your streaming stations and
                get out of the way.
              </p>
              <p>
                It works great on iOS and Android, plus CarPlay and Android
                Auto.
              </p>
            </div>
          </section>

          <section className="section prose" id="stations">
            <h2 className="section__title">Find something you love</h2>
            <div className="section__copy">
              <p>
                Built-in catalog of over 50,000 streaming radio stations that
                are online right now.
              </p>
              <p>
                You can save stations, shows, and individual episodes as
                favorites.
              </p>
            </div>
          </section>

          <section className="section prose" id="enhanced">
            <h2 className="section__title">Enhanced station support</h2>
            <div className="section__copy">
              <p>
                StreamLover knows how to read the schedule, show details, and
                track metadata of some (not all) stations.
              </p>
              <p>
                For stations that support it, you can also quickly access past
                episodes on demand (similar to a podcast app).
              </p>
            </div>
          </section>

          <section className="section prose" id="friends">
            <h2 className="section__title">Share and discover with friends</h2>
            <div className="section__copy">
              <p>
                You don't have to create an account, but if you do, you can
                share with friends and see what they're loving within
                StreamLover.
              </p>
              <p>
                It's a "micro" social network focused on internet radio, without
                all the other noise. (If you love{" "}
                <a
                  href="https://letterboxd.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Letterboxd
                </a>{" "}
                for movies, you know what we're trying to do here.)
              </p>
            </div>
          </section>

          <section className="section prose" id="humans">
            <h2 className="section__title">
              Made of <span className="heart">♥</span>, not slop
            </h2>
            <div className="section__copy">
              <p>
                There are a lot of sloppy vibe-coded apps out there. I hope
                you'll try StreamLover and agree it isn't one of them.
              </p>
              <p>
                I had this crazy idea in 2020, started building in 2022, and am
                just getting it finished in 2026. I've been a professional
                software engineer for decades and have{" "}
                <a href="https://github.com/mik3y">
                  several open source projects
                </a>
                .
              </p>
              <p>
                Most of all, I am just crazy about wanting this thing to exist.
              </p>
            </div>
          </section>
        </div>
        <SiteFooter />
      </main>
    </>
  );
};

export default Homepage;
